export const UPDATE_ADDRESS_STATUS_SUCCESS = 'UPDATE_ADDRESS_STATUS_SUCCESS';
export const UPDATE_ADDRESS_STATUS_REQUEST = 'UPDATE_ADDRESS_STATUS_REQUEST';
export const UPDATE_ADDRESS_STATUS_FAILURE = 'UPDATE_ADDRESS_STATUS_FAILURE';
export const UPDATE_ADDRESS_STATUS_RESET = 'UPDATE_ADDRESS_STATUS_RESET';
export const updateAddressStatusSuccess = (payload) => ({
    type: UPDATE_ADDRESS_STATUS_SUCCESS,
    payload,
});
export const updateAddressStatusRequest = (payload) => ({
    type: UPDATE_ADDRESS_STATUS_REQUEST,
    payload,
});
export const updateAddressStatusFailure = (payload) => ({
    type: UPDATE_ADDRESS_STATUS_FAILURE,
    payload,
});
export const updateAddressStatusReset = () => ({
    type: UPDATE_ADDRESS_STATUS_RESET
});
